import { getCookies } from '@moonpig/web-core-cookies'
import type { NextPageContext } from 'next'

export const getProxyApiStoreNamespace = (
  ctx: NextPageContext,
): string | null => {
  return getCookies(ctx)['mnpg-proxy-api-store-namespace'] || null
}
